if (!customElements.get('fws-gallery-video-player')) {
  customElements.define('fws-gallery-video-player', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const video = this.querySelector('video');
      const play = this.querySelector('[data-video-play]');
      const sound = this.querySelector('[data-video-sound]');
      if (!video || !play || !sound) return;
      const options = {signal: this.events.signal};
      let userPaused = false;
      const render = () => {
        const playing = !video.paused && !video.ended;
        this.classList.toggle('is-playing', playing);
        play.setAttribute('aria-label', playing ? play.dataset.pauseLabel : play.dataset.playLabel);
        sound.setAttribute('aria-label', video.muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
        sound.setAttribute('aria-pressed', String(!video.muted));
        sound.innerHTML = video.muted
          ? '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="m16 9 5 6m0-6-5 6"/></svg>'
          : '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
      };
      const start = () => {
        const attempt = video.play();
        if (attempt?.catch) attempt.catch(render);
      };
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      play.addEventListener('click', () => {
        if (video.paused) { userPaused = false; start(); }
        else { userPaused = true; video.pause(); }
      }, options);
      sound.addEventListener('click', () => { video.muted = !video.muted; render(); }, options);
      ['playing', 'pause', 'ended', 'volumechange', 'error'].forEach(name => video.addEventListener(name, render, options));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotion.matches) video.pause();
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) video.pause();
          else if (!userPaused && !reducedMotion.matches) start();
        });
      }, {threshold: 0.2});
      this.observer.observe(this);
      render();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
